<template>
  <WCModal @dismiss="isLoading ? null : dismiss('Dismissed')">
    <WCModalHeader class="d-flex justify-content-between">
      <h3>{{ $t('addNewCard') }}</h3>
      <button @click="dismiss('Dismissed')" class="btn btn-link underline-link-from-center">
        {{ $t('cancel') }}
      </button>
    </WCModalHeader>
    <WCModalBody>
      <WCCreditCardForm
        :paymentMethod="paymentMethod"
        @form-changed="tokenizeCallback = $event"
        @update:valid="continueEnabled = $event"
      />
    </WCModalBody>
    <WCModalFooter>
      <WCInvisibleRecaptcha ref="recaptcha" />
      <button
        @click="addCard"
        :disabled="!continueEnabled"
        class="btn btn-primary btn-block save-btn"
      >
        {{ $t('saveCard') }}
      </button>
    </WCModalFooter>
  </WCModal>
</template>

<script>
import axios from 'axios';
import WCModal from '@/modules/modals/components/WCModal/WCModal.vue';
import WCModalHeader from '@/modules/modals/components/WCModalHeader/WCModalHeader.vue';
import WCModalBody from '@/modules/modals/components/WCModalBody/WCModalBody.vue';
import WCModalFooter from '@/modules/modals/components/WCModalFooter/WCModalFooter.vue';
import ModalMixin from '@/modules/modals/mixins/ModalMixin';
import WCInvisibleRecaptcha from '@/modules/recaptcha/components/WCInvisibleRecaptcha/WCInvisibleRecaptcha.vue';
import SpinnerService from '@/services/spinner.service';
import WCCreditCardForm from '../WCCreditCardForm/WCCreditCardForm.vue';

export default {
  props: {
    paymentMethod: {
      type: Object,
    },
  },
  mixins: [ModalMixin],
  components: {
    WCCreditCardForm,
    WCModal,
    WCModalHeader,
    WCModalBody,
    WCModalFooter,
    WCInvisibleRecaptcha,
  },
  data() {
    return {
      continueEnabled: false,
      tokenizeCallback: null,
      isLoading: false,
    };
  },
  methods: {
    updateValid(payload) {
      this.continueEnabled = payload;
    },
    async addCard() {
      this.isLoading = true;
      SpinnerService.open();
      try {
        const ccInfo = await this.tokenizeCallback();
        // Always send expiry to backend as MM/YY or MMYY
        if (ccInfo?.expiry?.length > 5) {
          if (ccInfo.expiry.includes('/')) {
            ccInfo.expiry = ccInfo.expiry.replace('/', '');
          }
          ccInfo.expiry = ccInfo.expiry.slice(0, 2) + ccInfo.expiry.slice(4);
        }
        const payload = {
          ...ccInfo,
          recaptcha: await this.$refs.recaptcha.execute(),
        };
        const response = await axios.post('api/me/wallet/add-token', payload);
        this.close(response);
      } catch (error) {
        console.error(error);
        this.close(null);
      } finally {
        this.isLoading = false;
        SpinnerService.close();
      }
      this.continueEnabled = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';
@include media-breakpoint-down(sm) {
  .save-btn {
    width: 100%;
  }
}
</style>
